import { ColumnDefinition } from '../../sharedComponents/table/SortedTableHeader';

export enum TransportAssignmentTableColumn {
    HAS_CHANGES = 'hasChanges',
    EXTERNAL_ID = 'externalId',
    STATUS = 'status',
    MODEL = 'model',
    MODEL_GROUP = 'modelGroup',
    ORDER_ISSUE_DATE = 'orderIssueDate',
    FROM = 'from',
    FROM_LOCATION_ID = 'fromLocationId',
    REQUESTED_PICKUP = 'requestedPickup',
    PICKUP = 'pickup',
    TO = 'to',
    TO_LOCATION_ID = 'toLocationId',
    REQUESTED_DELIVERY = 'requestedDelivery',
    DELIVERY = 'delivery',
    MEANS_OF_TRANSPORT = 'meansOfTransport',
    ACTION = 'action',
}

export const transportAssignmentColumnDefinition: ColumnDefinition<TransportAssignmentTableColumn>[] = [
    {
        column: TransportAssignmentTableColumn.HAS_CHANGES,
        labelId: undefined,
        sortable: false,
        fixedWith: 40,
    },
    {
        column: TransportAssignmentTableColumn.EXTERNAL_ID,
        labelId: 'outboundPortal.transportAssignments.table.loadOrder',
        sortable: false,
        alwaysVisible: true,
    },
    {
        column: TransportAssignmentTableColumn.STATUS,
        labelId: 'outboundOrderBook.common.heading.status',
        sortable: true,
    },
    {
        column: TransportAssignmentTableColumn.MODEL,
        labelId: 'outboundOrderBook.common.heading.modelOrCapacity',
        sortable: false,
    },
    {
        column: TransportAssignmentTableColumn.MODEL_GROUP,
        labelId: 'outboundPortal.transportAssignments.table.modelGroup',
        sortable: false,
    },
    {
        column: TransportAssignmentTableColumn.ORDER_ISSUE_DATE,
        labelId: 'outboundOrderBook.common.heading.orderIssuedAt',
        sortable: false,
    },
    {
        column: TransportAssignmentTableColumn.FROM,
        labelId: 'outboundPortal.common.table.from',
        sortable: true,
    },
    {
        column: TransportAssignmentTableColumn.FROM_LOCATION_ID,
        labelId: 'outboundPortal.common.table.from.locationId',
        sortable: false,
    },
    {
        column: TransportAssignmentTableColumn.REQUESTED_PICKUP,
        labelId: 'outboundPortal.transportAssignments.sidebar.assignmentInformation.requestedPickUpDateInterval',
        sortable: true,
    },
    {
        column: TransportAssignmentTableColumn.PICKUP,
        labelId: 'outboundPortal.transportAssignments.table.pickUpDate',
        sortable: true,
    },
    {
        column: TransportAssignmentTableColumn.TO,
        labelId: 'outboundPortal.common.table.to',
        sortable: true,
    },
    {
        column: TransportAssignmentTableColumn.TO_LOCATION_ID,
        labelId: 'outboundPortal.common.table.to.locationId',
        sortable: false,
    },
    {
        column: TransportAssignmentTableColumn.REQUESTED_DELIVERY,
        labelId: 'outboundPortal.transportAssignments.sidebar.assignmentInformation.requestedDeliveryDate',
        sortable: true,
    },
    {
        column: TransportAssignmentTableColumn.DELIVERY,
        labelId: 'outboundPortal.transportAssignments.table.deliveryDate',
        sortable: true,
    },
    {
        column: TransportAssignmentTableColumn.MEANS_OF_TRANSPORT,
        labelId: 'outboundOrderBook.common.heading.meansOfTransport',
        sortable: false,
    },
    {
        column: TransportAssignmentTableColumn.ACTION,
        labelId: 'outboundPortal.transportAssignments.table.action',
        sortable: false,
    },
];
